import { createUser, verifyUserEmail, registerSuccess, registerError } from 'modules/auth/actions'
import { REGISTER } from 'modules/auth/action-types'
import { replace } from 'react-router-redux'
import { ACCOUNT_BILLING_PATH, SITES_PATH } from 'config'

export default ({ dispatch }) => next => action => {
  const result = next(action);

  if (typeof action === 'object') {
    switch (action.type) {
      case REGISTER:
        createUser(action.payload.email, action.payload.password)
          .then(user => {
            if (action.payload.name) {
              return user.updateProfile({ displayName: action.payload.name })
                .then(() => user)
            }
            else {
              return user
            }
          })
          .then(user => verifyUserEmail(user))
          .then(user => dispatch(registerSuccess(user)))
          .then(() => {
            if (typeof window.Intercom !== 'undefined') {
              window.Intercom("update", {
                name: action.payload.name,
                email: action.payload.email
              });
            }
          })
          .then(() => {
            if (typeof action.payload.planId !== 'undefined' && action.payload.planId !== 'basic') {
              return dispatch(replace(ACCOUNT_BILLING_PATH/*.replace(':plan?', action.payload.planId)*/));
            }
            else {
              return dispatch(replace(SITES_PATH));
            }
          })
          .catch(error => dispatch(registerError(error)))
        break;
      default:
        break;
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/redux/middlewares/register.js